import { render, staticRenderFns } from "./BaseInfoBlock.vue?vue&type=template&id=55a0b196&lang=pug"
import script from "./BaseInfoBlock.vue?vue&type=script&lang=js"
export * from "./BaseInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoBlock.vue?vue&type=style&index=0&id=55a0b196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports